module.exports = __webpack_public_path__ + "static/media/Timed_Bonus_Closed@3x.9212160e.png";